import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Rank')
export default class Rank {
  constructor() {
    this.rankCode = '';
    this.title = '';
    this.fee = '';
    this.thumbnail = '';
    this.alternativeText = '';
    this.paymentType = 'free';
    this.requestPeriodEnd = '';
  }

  public rankCode: string;

  public title: string;

  public fee: string;

  public thumbnail: string;

  public alternativeText: string;

  public paymentType: string;

  public requestPeriodEnd: string;
}
